import "../assets/Checkbox.css";
import { defineComponent as _, ref as s, openBlock as g, createElementBlock as x, withModifiers as y, unref as i, createVNode as B, createElementVNode as f } from "vue";
import { d as C } from "./debounce.BDLEW31m.js";
import { _ as w } from "./Tooltip.vue_vue_type_style_index_0_lang.BZsawpJG.js";
const V = ["checked", "disabled"], D = /* @__PURE__ */ _({
  __name: "Checkbox",
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(d, { expose: p, emit: m }) {
    const r = d, k = m, c = s(), o = s(r.checked), a = s();
    function h() {
      a.value.hide();
    }
    const n = C(() => {
      o.value = !o.value, h(), k("update:modelValue", o.value);
    }, 200, { leading: !0, trailing: !1 });
    function b() {
      var u;
      const {
        top: t,
        left: e,
        width: l
      } = ((u = c.value) == null ? void 0 : u.getBoundingClientRect()) || {};
      a.value.show(r.errorMessage, {
        top: t,
        left: e + l / 2
      });
    }
    function v() {
      const t = !r.required || !!o.value;
      return t || b(), t;
    }
    return p({
      validate: v,
      isChecked: o,
      id: r.id
    }), (t, e) => (g(), x("div", {
      class: "tool--checkbox",
      onMousedown: e[0] || (e[0] = y(
        //@ts-ignore
        (...l) => i(n) && i(n)(...l),
        ["left"]
      )),
      onClick: e[1] || (e[1] = //@ts-ignore
      (...l) => i(n) && i(n)(...l)),
      checked: o.value,
      disabled: d.disabled
    }, [
      B(w, {
        ref_key: "errorTooltipRef",
        ref: a,
        "auto-hide": 3e3
      }, null, 512),
      e[2] || (e[2] = f("input", {
        class: "tool--checkbox__input",
        type: "checkbox"
      }, null, -1)),
      f("span", {
        class: "tool--checkbox__checkmark",
        ref_key: "checkmarkDom",
        ref: c
      }, null, 512)
    ], 40, V));
  }
});
export {
  D as _
};
//# sourceMappingURL=Checkbox.vue_vue_type_style_index_0_lang.w_4wTui5.js.map
